export default __webpack_public_path__ + "static/media/bike-1.1a152deb.svg";